export default "__VITE_ASSET__DkGftHfd__"